<template>
    <div>
        <vx-card no-shadow class="mb-8"  :key="index" v-for="(item, index) in getStateUserMigrationRegistration" v-if="getStateUserMigrationRegistration.length > 0">
            <div class="vx-row">

                <div class="vx-col md:w-1/2 w-full">
                    <span class="header_font">{{ $t('Documents') }}</span>
                    <p><span class="font">{{$t('document_type')}}:</span> {{ item.document_type ? item.document_type.name : '' }}</p>
                    <p><span class="font">{{$t('series')}}:</span> {{ item.series }}</p>
                    <p><span class="font">{{$t('number')}}:</span> {{ item.number }}</p>
                    <p><span class="font">{{$t('start_date')}}:</span> {{ item.start_date }}</p>
                    <p><span class="font">{{$t('end_date')}}:</span> {{ item.end_date }}</p>
                </div>

                <div class="vx-col md:w-1/2 w-full">
                    <span class="header_font">{{ $t('Visas') }}</span>
                    <p><span class="font">{{$t('visa_category')}}:</span> {{ item.visa_category ? item.visa_category.name : '' }}</p>
                    <p><span class="font">{{$t('trip_purpose')}}:</span>  {{ item.trip_purpose ? item.trip_purpose.name : '' }}</p>
                    <p><span class="font">{{$t('receiving_party')}}:</span> {{ item.receiving_party ? item.receiving_party.name : ''}}</p>
                    <p><span class="font">{{$t('visa_id')}}:</span> {{ item.visa_id }}</p>
                    <p><span class="font">{{$t('invitation_number')}}:</span> {{ item.invitation_number }}</p>
                    <p><span class="font">{{$t('decision_number')}}:</span> {{ item.decision_number }}</p>
                    <p><span class="font">{{$t('decision_date')}}:</span> {{ item.decision_date }}</p>
                    <p><span class="font">{{$t('issuing_authority')}}:</span> {{ item.issuing_authority ? item.issuing_authority.name : '' }}</p>
                    <p><span class="font">{{$t('Comment')}}:</span> {{ item.comment }}</p>

                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Page",
    computed:{
        ...mapGetters({
            getStateUserMigrationRegistration: 'profile/getStateUserMigrationRegistration'
        })
    },
};
</script>

<style scoped>
.font{
    font-weight: bold;
}
.header_font{
    font-weight: bold;
    font-size: 1.2em;
}
</style>
